import * as React from 'react'

export const HeadingTwoIcon = React.memo(({
  className,
  ...props
}) => {
  return (
    <svg
      width='24'
      height='24'
      className={className}
      viewBox='0 0 24 24'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M23.2516 20.6997H15.0177V18.9675L17.9745 15.9785C18.85 15.0815 19.422 14.4612 19.6906 14.1174C19.9591 13.7683 20.1525 13.446 20.2706 13.1506C20.3888 12.8552 20.4479 12.5491 20.4479 12.2322C20.4479 11.7595 20.3163 11.4077 20.0531 11.1768C19.7953 10.9458 19.4489 10.8303 19.0138 10.8303C18.5573 10.8303 18.1141 10.9351 17.6844 11.1445C17.2548 11.354 16.8063 11.6521 16.339 12.0388L14.9855 10.4355C15.5656 9.94141 16.0463 9.59229 16.4276 9.38818C16.809 9.18408 17.2252 9.02832 17.6764 8.9209C18.1276 8.80811 18.6324 8.75171 19.191 8.75171C19.9269 8.75171 20.5768 8.88599 21.1407 9.15454C21.7047 9.4231 22.1425 9.79907 22.454 10.2825C22.7655 10.7659 22.9213 11.3191 22.9213 11.9421C22.9213 12.4846 22.8246 12.9949 22.6312 13.4729C22.4432 13.9456 22.1478 14.4316 21.745 14.9312C21.3475 15.4307 20.6439 16.1423 19.6342 17.0662L18.1195 18.4922V18.605H23.2516V20.6997Z'
        fill='currentColor'
      />
      <path
        d='M3.85706 2.69971V9.44971H9.85706V2.69971H12.8571V20.6997H9.85706V12.8247H3.85706V20.6997H0.857056V2.69971H3.85706Z'
        fill='currentColor'
      />
    </svg>
  )
})

HeadingTwoIcon.displayName = 'HeadingTwoIcon'
